import { Grid, Box, CircularProgress } from '@mui/material';
import DesktopCoupon from './Coupon/DesktopCoupon';
import MobileCoupon from './Coupon/MobileCoupon';

const CouponsList = ({ isMobile, coupons, loading, loadingMore, language }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2, px: isMobile ? 2 : 6 }}>
      <Grid
        container
        rowSpacing={isMobile ? 1 : 3}
        columnSpacing={isMobile ? 1 : 3}
        columns={20}
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
        }}
      >
        {coupons.map((coupon) => (
          <Grid
            item
            key={coupon.coupon_id}
            size={{ xs: 20, sm: 10, md: 5, lg: 4 }}
            sx={{
              maxWidth: '100%',
            }}
          >
            {isMobile ? (
              <MobileCoupon coupon={coupon} language={language} />
            ) : (
              <DesktopCoupon coupon={coupon} language={language} />
            )}
          </Grid>
        ))}
      </Grid>
      {loadingMore && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CircularProgress size={50} />
        </Box>
      )}
    </Box>
  );
};

export default CouponsList;